import { Inject, Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { InjectionToken } from '@angular/core';

export interface DateFormatOptions {
  format: 'dd.mm.yyyy' | 'mm/dd/yyyy' | 'yyyy-mm-dd';
  DELIMITER: string;
}

export const DATE_FORMAT_OPTIONS = new InjectionToken<DateFormatOptions>('DATE_FORMAT_OPTIONS');

@Injectable()
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {

  private readonly DELIMITER;

  constructor(@Inject(DATE_FORMAT_OPTIONS) private options: DateFormatOptions) {
    super();
    this.DELIMITER = this.options.DELIMITER;
  }

  parse(value: string): NgbDateStruct | null {
    if (!value) {
      return null;
    }

    const parts = value.trim().split(this.options.DELIMITER);
    if (parts.length !== 3) {
      return null;
    }

    let day: number;
    let month: number;
    let year: number;

    switch (this.options.format) {
      case 'dd.mm.yyyy':
        [day, month, year] = parts.map(p => parseInt(p, 10));
        break;
      case 'mm/dd/yyyy':
        [month, day, year] = parts.map(p => parseInt(p, 10));
        break;
      case 'yyyy-mm-dd':
        [year, month, day] = parts.map(p => parseInt(p, 10));
        break;
      default:
        return null;
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    if (!date) {
      return '';
    }

    const day = String(date.day).padStart(2, '0');
    const month = String(date.month).padStart(2, '0');
    const year = String(date.year);
    const sep = this.options.DELIMITER;

    switch (this.options.format) {
      case 'dd.mm.yyyy':
        return `${day}${sep}${month}${sep}${year}`;
      case 'mm/dd/yyyy':
        return `${month}${sep}${day}${sep}${year}`;
      case 'yyyy-mm-dd':
        return `${year}${sep}${month}${sep}${day}`;
      default:
        return `${day}${sep}${month}${sep}${year}`;
    }
  }
}
